import { formatInTimeZone, toDate } from "date-fns-tz";
import { ja } from "date-fns/locale";

export const toLocaleTextAsDate = (date: Date, hiddenYear?: boolean) => {
  const formatStr = hiddenYear ? "MM/dd(E)" : "yyyy/MM/dd(E)";
  try {
    return formatInTimeZone(date, "+09:00", formatStr, { locale: ja });
  } catch (e) {
    throw new Error(`Failed toLocaleTextAsDate: ${date}`, { cause: e });
  }
};

export const toLocaleTextAsTime = (time: Date) => {
  try {
    return formatInTimeZone(time, "+09:00", "HH:mm");
  } catch (e) {
    throw new Error(`Failed toLocaleTextAsTime: ${time}`, { cause: e });
  }
};

export const toLocaleTextAsDateTime = (datetime: Date) => {
  try {
    return formatInTimeZone(datetime, "+09:00", "yyyy/MM/dd(E) HH:mm", {
      locale: ja,
    });
  } catch (e) {
    throw new Error(`Failed toLocaleTextAsDateTime: ${datetime}`, { cause: e });
  }
};

export const toIso8601Date = (date: Date) => {
  try {
    return formatInTimeZone(date, "+09:00", "yyyy-MM-dd");
  } catch (e) {
    throw new Error(`Failed toIso8601Date: ${date}`, { cause: e });
  }
};

export const fromIso8601Date = (date: string) => {
  try {
    return toDate(date, { timeZone: "+09:00" });
  } catch (e) {
    throw new Error(`Failed fromIso8601Date: ${date}`, { cause: e });
  }
};

export const toIso8601DateTime = (datetime: Date) => {
  try {
    return formatInTimeZone(datetime, "+09:00", "yyyy-MM-dd'T'HH:mm:ssXXX");
  } catch (e) {
    throw new Error(`Failed toIso8601DateTime: ${datetime}`, { cause: e });
  }
};

export const fromIso8601DateTime = (datetime: string) => {
  try {
    return toDate(datetime, { timeZone: "+09:00" });
  } catch (e) {
    throw new Error(`Failed fromIso8601DateTime: ${datetime}`, { cause: e });
  }
};

export const toIso8601Time = (date: Date) => {
  try {
    return formatInTimeZone(date, "+09:00", "HH:mm:ss");
  } catch (e) {
    throw new Error(`Failed toIso8601Time: ${date}`, { cause: e });
  }
};

export const fromIso8601Time = (time: string): Date => {
  // Add seconds if they're missing (HH:MM -> HH:MM:00)
  const timeWithSeconds = time.match(/^\d{1,2}:\d{2}$/) ? `${time}:00` : time;
  const datetime = `1970-01-01T${timeWithSeconds}`;
  try {
    return toDate(datetime, { timeZone: "+09:00" });
  } catch (e) {
    throw new Error(`Failed fromIso8601Time: ${time}`, { cause: e });
  }
};

export const isValidDate = (date: Date | null | undefined): date is Date => {
  return !!date && !Number.isNaN(date.getDate());
};

export const isPastFromIso8601DateTime = (dateStr: string) => {
  const date = fromIso8601DateTime(dateStr);
  const now = new Date();
  return date < now;
};
